import { render, staticRenderFns } from "./SelectCoin.vue?vue&type=template&id=47c0cdac&"
import script from "./SelectCoin.vue?vue&type=script&lang=js&"
export * from "./SelectCoin.vue?vue&type=script&lang=js&"
import style0 from "./SelectCoin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports